/**
 * Configuração i18n - react-i18next
 * Detecta idioma do navegador (pt/en) e persiste preferência no localStorage
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptCommon from './locales/pt/common.json';
import ptLogin from './locales/pt/login.json';
import ptProfile from './locales/pt/profile.json';
import ptPlans from './locales/pt/plans.json';
import ptBuilder from './locales/pt/builder.json';
import ptMaster from './locales/pt/master.json';
import ptCollab from './locales/pt/collab.json';
import ptCricket from './locales/pt/cricket.json';
import enCommon from './locales/en/common.json';
import enLogin from './locales/en/login.json';
import enProfile from './locales/en/profile.json';
import enPlans from './locales/en/plans.json';
import enBuilder from './locales/en/builder.json';
import enMaster from './locales/en/master.json';
import enCollab from './locales/en/collab.json';
import enCricket from './locales/en/cricket.json';

const STORAGE_KEY = 'gepetto_lang';

function getInitialLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'pt' || saved === 'en') return saved;
  } catch {}
  const browser = navigator.language?.toLowerCase().slice(0, 2);
  return browser === 'pt' ? 'pt' : 'en';
}

i18n.use(initReactI18next).init({
  // Evita log de patrocínio Locize no console (não é erro; é aviso da lib).
  showSupportNotice: false,
  resources: {
    pt: {
      common: ptCommon,
      login: ptLogin,
      profile: ptProfile,
      plans: ptPlans,
      builder: ptBuilder,
      master: ptMaster,
      collab: ptCollab,
      cricket: ptCricket,
    },
    en: {
      common: enCommon,
      login: enLogin,
      profile: enProfile,
      plans: enPlans,
      builder: enBuilder,
      master: enMaster,
      collab: enCollab,
      cricket: enCricket,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'login', 'profile', 'plans', 'builder', 'master', 'collab', 'cricket'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {}
});

export default i18n;
